import CustomAuth from '../../containers/registration/custom-auth/CustomAuth';
import { useRegistration } from './RegistrationContext';

const BasicDetails = () => {
    const {
        signAs,
        setDigioSuccessData,
        checkIcon,
        setActiveTab,
        setCandidateType,
        setKYCEmail,
        setPageLoading,
        setShowSelectAccountType,
        activeTab,
        ConfirmUnclaimedCandidateInvitationId,
        unclaimedData,
        setShowOTPBtn,
        showOTPBtn,
        setShowNextTab,
        showNextTab,
        setShowPasswordTab,
        showPasswordTab,
    } = useRegistration();

    return (
        <div>
            <CustomAuth
                candidateType={signAs}
                isNewRegUnclaimedAcc={ConfirmUnclaimedCandidateInvitationId ? true : false}
                claimedCandidateData={unclaimedData || ''}
                newRegUnclaimedId={ConfirmUnclaimedCandidateInvitationId || ''}
                setDigioSuccessData={setDigioSuccessData}
                disableButton={!checkIcon}
                handleSelect={(key: string, key2: string, value: any) => {
                    setActiveTab(key);
                    setCandidateType(key2);
                    setKYCEmail(value);
                }}
                setPageLoading={(item) => setPageLoading(item)}
                setShowSelectAccountType={setShowSelectAccountType}
                setShowPasswordTab={setShowPasswordTab}
                showPasswordTab={showPasswordTab}
                setShowOTPBtn={setShowOTPBtn}
                showOTPBtn={showOTPBtn}
                activeTab={activeTab}
                setShowNextTab={setShowNextTab}
                showNextTab={showNextTab}
            />
        </div>
    );
};

export default BasicDetails;
